import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { updateLocalBasket } from 'components/basket/localStore';
import { EOrderNonceKey, orderApi } from 'components/order/orderApi';
import type { ApplicationState } from 'store/store';
import {
    addItem,
    addItems,
    updateQuantity,
    removeItem,
    setBasket,
    setBasketLocationId,
    addAwardAdjustment,
    removeReward,
    resetRewards,
    setDeliveryLocation,
    setCheckId,
    setTimeslot,
    setNote,
    setPrepTimePadding,
    setSuggestionsShowed,
    setDeliveryTime,
    setDeliveryAddressId,
    rehydrate
} from './basketSlice';

export const basketListenerMiddleware = createListenerMiddleware();

// Sync to localStorage after any basket action (except resetBasketState, handled by thunks)
basketListenerMiddleware.startListening({
    matcher: isAnyOf(
        addItem,
        addItems,
        updateQuantity,
        removeItem,
        setBasket,
        setBasketLocationId,
        addAwardAdjustment,
        removeReward,
        resetRewards,
        setDeliveryLocation,
        setCheckId,
        setTimeslot,
        setNote,
        setPrepTimePadding,
        setSuggestionsShowed,
        setDeliveryTime,
        setDeliveryAddressId,
        rehydrate
    ),
    effect: (_action, listenerApi) => {
        const state = listenerApi.getState() as ApplicationState;
        updateLocalBasket(state.basket);
    }
});

// Reset order nonce on delivery location or check ID change
basketListenerMiddleware.startListening({
    matcher: isAnyOf(setDeliveryLocation, setCheckId),
    effect: () => {
        orderApi.resetNonceByKey(EOrderNonceKey.JOIN_ORDER);
    }
});
